import { render } from "./index.vue?vue&type=template&id=0dbc47b2&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=0dbc47b2&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbc47b2"]])

export default __exports__